import { generateContext } from 'parkdepot-shared/utils/contextGenerator'
import { ErrorFlow } from '../../types/errorFlow.interface'

export interface IErrorFlowContext {
    errorFlow: ErrorFlow
    setErrorFlow(errorFlow: ErrorFlow): void
}

const [ErrorFlowContext, ErrorFlowContextProvider] = generateContext<IErrorFlowContext>()

export { ErrorFlowContext }
export default ErrorFlowContextProvider
